import { useState } from 'preact/hooks';
import { STEPS } from '../constants/ReturnRequest.constant';

interface ReturnSubmissionSteps {
  currentStep: string;
  goToViewStep: () => void;
  goToEditStep: () => void;
}

const useSteps = (): ReturnSubmissionSteps => {
  const [currentStep, setCurrentStep] = useState<string>(STEPS.EDIT);

  const goToViewStep = () => {
    setCurrentStep(STEPS.VIEW);
  };

  const goToEditStep = () => {
    setCurrentStep(STEPS.EDIT);
  };

  return {
    currentStep,
    goToViewStep,
    goToEditStep,
  };
};

export { useSteps };
